export const handleShare = (news: any) => {
    if (navigator.share) {
      navigator.share({
        title: news.title,
        text: news.description,
        url: window.location.href,
      })
      .catch((error) => console.log('Error sharing', error));
    } else {
      alert('Share functionality not available on this browser');
    }
  };



  export const replaceCategoryName = (value: any): string => {
  // Ensure value is a string before attempting string methods
  if (typeof value !== 'string') {
    return value; // Return as is if not a string
  }

  const pattern = /(cat\/|gallery\/)/g; // Define the pattern once

  // Check if either "cat/" or "gallery/" is present in the value
  if (pattern.test(value)) {
    // If present, apply the replacement
    const innerSlug = value.replace(pattern, '');
    return innerSlug;
  } else {
    // If neither is present, return the original value as is
    return value;
  }
};


  

 

